import { createSelector } from '@ngrx/store';
import { getRoles } from 'src/app/shared/selectors/roles.selectors';
import { getDragonflyState } from '../reducers';

export const getUpdateTagState = createSelector(getDragonflyState, (state) => state?.updateTag);

export const getTagLabel = createSelector(getUpdateTagState, (state) => state?.updateTagLabel);

export const getTagCode = createSelector(getUpdateTagState, (state) => state?.updateTagCode);

export const getTagType = createSelector(getUpdateTagState, (state) => state?.updateTagType);

export const getUpdateTagDisabled = createSelector(getRoles, (roles) =>
  Object.keys(roles).includes('tags.update') ? false : true,
);

export const getTagTypeValidation = createSelector(getUpdateTagState, (state) =>
  !state?.updateTagType && state?.userSubmitted ? true : false,
);

export const getTagCodeValidation = createSelector(getUpdateTagState, (state) =>
  !state?.updateTagCode && state?.userSubmitted ? true : false,
);

export const getTagLabelValidation = createSelector(getUpdateTagState, (state) =>
  !state?.updateTagLabel && state?.userSubmitted ? true : false,
);

export const getFormIsValid = createSelector(getUpdateTagState, (state) =>
  state?.updateTagType && state?.updateTagCode && state?.updateTagLabel ? true : false,
);
